import React from 'react';

import './styles.css';


const getCertificationAgreementsText = () => (
  <div styleName="certificationMain">
    <div>
      <p styleName="certificationLink">
        <a href="/static/docs/My_IPO_Customer_Agreement_Folio_CLICK_THROUGH_VERSION_final_7-18-18.pdf" target="_blank">Cambria Capital, LLC dba My IPO Customer Agreement</a>
      </p>
      <p styleName="certificationLink">
        <a href="https://www.folioinstitutional.com/servlets/ProcessAction/document/folioDoc?partnerCode=IAFIRM&docTypeCode=ACA" target="blank">Folio Investments, Inc. Customer Agreement</a>
      </p>
      <p>
        <a href="/static/docs/FINRA_Rule_4311_Disclosure.pdf" target="_blank">FINRA Rule 4311 Disclosure</a>
      </p>
    </div>
  </div>
);

export default getCertificationAgreementsText;



// WEBPACK FOOTER //
// ./src/components/SignUp/CustomerAgreementsText.js